import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { API } from "../../config";
import { useNavigate, NavLink } from "react-router-dom";
import AuthFormContainer from "../../components/AuthFormContainer/AuthFormContainer";
import AuthFormFooter from "../../components/AuthFormFooter/AuthFormFooter";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";

// import { connect } from "react-redux";
// import * as reduxFunctions from "../../store/actions/index";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const loginUser = () => {
    setLoading(true);
    axios
      .post(`${API}/login`, {
        email: email,
        password: password,
      })
      .then((response) => {
        setLoading(false);
        localStorage.setItem("authToken", JSON.stringify(response.data.token));
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
        swal(
          "Login success!",
          "You will now redirect to the Home page!",
          "success",
          {
            button: "Okay",
          }
        ).then(() => {
          navigate("/");
        });
      })
      .catch((err) => {
        setLoading(false);
        swal("Error!", `${err.response.data.message}`, "error", {
          button: "Okay",
        });
      });
  };

  return (
    <AuthFormContainer
      form={
        <>
          <Input
            type={"email"}
            p={"Please enter your email"}
            setFn={setEmail}
          />
          <Input
            type={"password"}
            p={"Please enter your password"}
            setFn={setPassword}
          />
          <Button text={"Login"} clickFn={loginUser} loader={loading} />
          <AuthFormFooter
            l1={
              <>
                Forgot password?{" "}
                <NavLink to={"/forget"}>Click here to reset</NavLink>
              </>
            }
            l2={
              <>
                Don't have an account?{" "}
                <NavLink to={"/signup"}>Click here to Sign up</NavLink>
              </>
            }
          />
        </>
      }
    />
  );
};

// const mapStatetoProps = (state) => {
//   return {};
// };
// const mapDispatchtoProps = (dispatch) => {
//   return {
//     storeUserProfile: (data) => dispatch(reduxFunctions.storeUserProfile(data)),
//   };
// };
// export default connect(mapStatetoProps, mapDispatchtoProps)(Login);
export default Login;
